import { render, staticRenderFns } from "./AudioTemplate.vue?vue&type=template&id=65635c94&scoped=true&"
import script from "./AudioTemplate.vue?vue&type=script&lang=js&"
export * from "./AudioTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AudioTemplate.vue?vue&type=style&index=0&id=65635c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65635c94",
  null
  
)

export default component.exports